export const iconFontAwesomeFoodBeverageMugHot = (
	<i className="fa-solid fa-mug-hot"></i>
);
